
import {
  BuilderElementProjectManagement,
  BuilderElementProjectManagementValue
} from "@/types/elements";
import defensiveCopy from "@/util/defensive-copy";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";

@Component({
  components: { DropdownInput }
})
export default class ElementStudioProjectManagement extends Vue {
  @Prop()
  value!: BuilderElementProjectManagement;

  get dropdownItems(): BuilderElementProjectManagementValue[] {
    return ["yes", "no", "unknown", "sort of"];
  }

  updateValueForKey(
    key: keyof BuilderElementProjectManagement,
    value: BuilderElementProjectManagementValue | undefined
  ) {
    const newBuilderElementProjectManagementValue = defensiveCopy(this.value);
    newBuilderElementProjectManagementValue[key] = value;
    this.emit(newBuilderElementProjectManagementValue);
  }

  updateNotes(newNotes: unknown) {
    const newBuilderElementProjectManagementValue = defensiveCopy(this.value);
    newBuilderElementProjectManagementValue.notes =
      typeof newNotes === "string" ? newNotes : "";
    this.emit(newBuilderElementProjectManagementValue);
  }

  emit(newValue: BuilderElementProjectManagement) {
    this.$emit("input", newValue);
  }
}
